import React from 'react';
import './section.css';
// import productImg from '../resources/green-heart.svg';

// const MyLink = ({href, children}) => {
//     return (
// <a className="action-link" href={href}>
//     {children}
// </a>
//     )
// }

//<MyLink href={`/products/${slug}`}></MyLink>
const ProductView = ({id, image, name, slug}={}) => {
    return (
<div className="product-tile-container">
    <img src={require(`../images/${image}`)} alt={'product placeholder'} />
    <h2>{name}</h2>
</div>
    )
}

/* <img src={require(`../images/${image}`)} alt={'workshop placeholder'} /> */
const WorkshopView = ({id, link, day, time, location, title, subtitle}) => {
    return (
<div className="workshop-tile-container">
    <div className="center-v">
        <a href={link}>
            <div className="workshop-date-container">
                <span>{day}</span>
            </div>
            <div><span>{time}</span></div>
            <div className="workshop-location-container">
                <span>{location}</span>
            </div>
            <h2>{title}</h2>
            <h3>{subtitle}</h3>
        </a>
    </div>
</div>
    )
}

const DefaultView = ({id, description, heading}) => {
    return (
<div className="section-talking-points">
    <p className="item-details">{description}</p>
    {heading ? <ItemHeader {...heading} /> : ''}
</div>
    )
}

const AboutView = ({id, p}) => {
    return (
<p>{p}</p>
    )
}

const ItemViews = {
    Product: ProductView,
    Workshop: WorkshopView,
    About: AboutView,
    Default: DefaultView,
}

const ItemHeader = ({title, date, location}) => {
    return (
<div className="item-heading">
    <div className="item-title">{title}</div>
    <div className="item-date">{date}</div>
    <div className="item-location">{location}</div>
</div>
    )
}

const SectionView = ({items=[], section, viewClass='Default'}={}) => {
    console.log('viewclass: ' + viewClass)
    const TagName = ItemViews[viewClass];
    return (
<section>
    <div className="content-section">
        <div className="section-title">{section.title}</div>
        <ul className="section-element-list">
        {items.map(({id, ...item}) => <li key={id} className="section-element-item"><TagName {...{id, ...item}} /></li>)}
        </ul>
    </div>
</section>
    )
}

export default SectionView;



// WEBPACK FOOTER //
// ./src/components/section.js